import { render } from "./VenueSceneryGlyph.vue?vue&type=template&id=3bf86e5b"
import script from "./VenueSceneryGlyph.vue?vue&type=script&lang=js"
export * from "./VenueSceneryGlyph.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__